<div class="perfil-container">
  <!-- Header -->
  <header class="perfil-header">
    <div class="header-left">
      <button class="back-button" (click)="voltar()">
        <mat-icon>arrow_back</mat-icon>
        <span>VOLTAR</span>
      </button>
    </div>
    <div class="header-center">
      <div class="sispac-logo">
        <img
          *ngIf="isChristmasMode"
          src="../../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png"
          alt="Logo Natal"
          class="logo-icon">
        <img
          *ngIf="!isChristmasMode"
          src="../../../../assets/img/sispac-new/logo-sispac-new.png"
          alt="SISPAC Logo"
          class="logo-icon">
        <img
          *ngIf="!isChristmasMode"
          src="../../../../assets/img/sispac-new/nome-sispac-new.png"
          alt="SISPAC"
          class="logo-text">
      </div>
    </div>
    <div class="header-right"></div>
  </header>

  <!-- Main Content -->
  <main class="perfil-main">
    <div class="perfil-content">
      <!-- Título da Página -->
      <div class="page-title">
        <h2>Meu Perfil</h2>
      </div>

      <!-- Card do Perfil -->
      <div class="perfil-card">
        <!-- Avatar e Nome Principal -->
        <div class="perfil-avatar-section">
          <div class="avatar-circle">
            <mat-icon>account_circle</mat-icon>
          </div>
          <div class="perfil-greeting">
            <h3>Olá, {{ primeiroNome }}!</h3>
            <p class="greeting-subtitle">Bem-vindo ao seu perfil</p>
          </div>
        </div>

        <!-- Informações do Usuário -->
        <div class="perfil-info-section">
          <h4 class="section-title">Informações Pessoais</h4>

          <div class="info-grid">
            <div class="info-item">
              <div class="info-label">
                <mat-icon>person</mat-icon>
                <span>Nome Completo</span>
              </div>
              <div class="info-value">{{ usuario?.nome || 'Não informado' }}</div>
            </div>

            <div class="info-item">
              <div class="info-label">
                <mat-icon>business</mat-icon>
                <span>Lotação</span>
              </div>
              <div class="info-value">{{ usuario?.lotacao || 'Não informado' }}</div>
            </div>

            <div class="info-item" *ngIf="usuario?.email">
              <div class="info-label">
                <mat-icon>email</mat-icon>
                <span>E-mail</span>
              </div>
              <div class="info-value">{{ usuario?.email || 'Não informado' }}</div>
            </div>

            <div class="info-item" *ngIf="usuario?.cpf">
              <div class="info-label">
                <mat-icon>badge</mat-icon>
                <span>CPF</span>
              </div>
              <div class="info-value">{{ usuario?.cpf || 'Não informado' }}</div>
            </div>

            <div class="info-item" *ngIf="usuario?.matricula">
              <div class="info-label">
                <mat-icon>assignment_ind</mat-icon>
                <span>Matrícula</span>
              </div>
              <div class="info-value">{{ usuario?.matricula || 'Não informado' }}</div>
            </div>

            <div class="info-item" *ngIf="usuario?.cargo">
              <div class="info-label">
                <mat-icon>work</mat-icon>
                <span>Cargo</span>
              </div>
              <div class="info-value">{{ usuario?.cargo || 'Não informado' }}</div>
            </div>
          </div>
        </div>

        <!-- Ações do Perfil -->
        <div class="perfil-actions-section">
          <h4 class="section-title">Ações Rápidas</h4>

          <div class="actions-grid">
            <button mat-raised-button class="action-card modules-action" (click)="voltar()">
              <mat-icon>apps</mat-icon>
              <span>Voltar aos Módulos</span>
            </button>

            <button mat-raised-button class="action-card logout-action" (click)="logout()">
              <mat-icon>logout</mat-icon>
              <span>Sair do Sistema</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="perfil-footer">
    <div class="footer-content">
      <img
        *ngIf="isChristmasMode"
        src="../../../../assets/img/christmas/Gemini_Generated_Image_rcto20rcto20rcto-removebg-preview.png"
        alt="Logo Natal"
        class="footer-logo">
      <img
        *ngIf="!isChristmasMode"
        src="../../../../assets/img/sispac-new/colorida-com-escrita-verde.png"
        alt="Logo do Estado de Goiás"
        class="footer-logo">
      <div class="footer-info">
        <p>Controladoria-Geral do Estado de Goiás</p>
        <p>Desenvolvimento e Gestão</p>
      </div>
    </div>
  </footer>
</div>

